// test2940
(2940 && 0);
